import React, { useEffect, useState, useCallback, useRef } from "react";
import { saveAs } from 'file-saver';
import { Bar, Line } from "react-chartjs-2";
import axios from "axios";
import DailyChart from './DailyChart';
import { useHistory, useLocation } from "react-router";
import { URL } from "../../constants/insurance/constant.js";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
    Title
} from "chart.js";
import StatusWiseChart from "./StatusWiseChart";
ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Tooltip, Legend, Title);

const Chart = () => {
    const [barChartData, setBarChartData] = useState(null);
    const [lineChartData, setLineChartData] = useState(null);
    const [selectedBarData, setSelectedBarData] = useState([]);
    const [clickedDatasetLabel, setClickedDatasetLabel] = useState('');
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const tableRef = useRef(null);
    const [showBarTable, setShowBarTable] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showTable1, setShowTable1] = useState(false);
    const [endDate, setEndDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const history = useHistory();
    const children = JSON.parse(localStorage.getItem("children") || "[]");
    const title=children?.[0]?.entityName?.split(",")[0] || "";

    const handleDownloadCSV = () => {
        const headers = ['Date', 'Insurer ID', 'Insurer Name', 'ESales ID', 'Request ID'];
        const csvContent = [
            headers.join(','),
            ...selectedBarData.map(item =>
                [item.Date, item.insurer_id, item.insurer_name, item.esale_id, item.request_id].join(',')
            )
        ].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'Esales Data.csv');
    };
    let erIds;
    try {
        const storedData = localStorage.getItem("erIDs");
        erIds = storedData ? JSON.parse(storedData) : [];
    } catch {
        erIds = [];
    }
    const fetchData = async () => {
        try {
            const response = await axios.post(
                `${URL.fuser_url}api/v1/request/generic/getESalesCasesConversion/raw`,
                {
                    erIds,
                    startDate,
                    endDate
                },
                { headers: { "Content-Type": "application/json" } }
            );
            if (response.data && response.data.data) {
                setApiData(response.data.data);
                const groupedData = processData(response.data.data);
                setBarChartData(formatBarChartData(groupedData));
                setLineChartData(formatLineChartData(groupedData));
            }
        } catch (err) {
            console.error("Error fetching API data:", err);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    const processData = (data) => {
        const grouped = {};
        data.sort((a, b) => new Date(a.Date) - new Date(b.Date));
        const categorized = {};
        data.forEach(item => {
            const date = item.Date;
            if (!grouped[date]) {
                grouped[date] = {
                    date,
                    total_esales: 0,
                    orders_created: 0,
                    request_id: 0,
                    orders_not_created: 0,
                    qc_approved: 0,
                    in_process_cases: 0
                };
            }
            grouped[date].total_esales += 1;
            if (item.order_id !== 0) {
                grouped[date].request_id = item.request_id;
                grouped[date].orders_created += 1;
                if (item.status_id === 48) {
                    grouped[date].qc_approved += 1;
                } else {
                    grouped[date].in_process_cases += 1;
                }
            } else {
                grouped[date].orders_not_created += 1;
            }
        });
        return Object.values(grouped).sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    // Bar Chart
    const formatBarChartData = (data) => {
        const labels = data.map(item => item.date).sort((a, b) => new Date(a.date) - new Date(b.date));;
        const totalESales = data.map(item => item.total_esales);
        const ordersCreated = data.map(item => item.orders_created);
        const ordersNotCreated = data.map(item => item.orders_not_created);
        const qcApproved = data.map(item => item.qc_approved);
        const inProcessCases = data.map(item => item.in_process_cases);
        return {
            labels,
            datasets: [
                { label: "ESales Created", data: totalESales, backgroundColor: "#46A6EA" },
                { label: "Orders Created", data: ordersCreated, backgroundColor: "#6AC48E" },
                { label: "Order Not Created", data: ordersNotCreated, backgroundColor: "#474A8A" },
                { label: "QC Approved", data: qcApproved, backgroundColor: "#888888" },
                { label: "In Process Cases", data: inProcessCases, backgroundColor: "#F68B5F" }
            ]
        };
    };

    // Line Chart
    const formatLineChartData = (data) => {
        const labels = data.map(item => new Date(item.date).toLocaleDateString("en-US", { month: "short", day: "numeric" }));
        const esalesCases = data.map(item => 100);
        const ordersCreated = data.map(item => (item.orders_created / item.total_esales) * 100 || 0);
        const ordersNotCreated = data.map(item => (item.orders_not_created / item.total_esales) * 100 || 0);
        const qcApproved = data.map(item => (item.qc_approved / item.total_esales) * 100 || 0);
        const inProcessCases = data.map(item => (item.in_process_cases / item.total_esales) * 100 || 0);
        return {
            labels,
            datasets: [
                { label: "ESales Created", data: esalesCases, backgroundColor: "#46A6EA", borderColor: "#48A9EE" },
                { label: "Orders Created", data: ordersCreated, backgroundColor: "#6AC48E", borderColor: "#6AC48E" },
                { label: "Order Not Created", data: ordersNotCreated, backgroundColor: "#474A8A", borderColor: "#474A8A" },
                { label: "QC Approved", data: qcApproved, backgroundColor: "#888888", borderColor: "#888888" },
                { label: "In Process Cases", data: inProcessCases, backgroundColor: "#F68B5F", borderColor: "#F68B5F" }
            ]
        };
    };

    const redirectToHistory = (event, name) => {
        history.push("/" + localStorage.getItem("roleName") + "/appointments/" + name + "/history")
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    const handleBarClick = useCallback((elements) => {
        if (elements.length > 0) {
            const clickedIndex = elements[0].index;
            const clickedLabel = barChartData.labels[clickedIndex];
            const datasetIndex = elements[0].datasetIndex;
            const datasetLabel = barChartData.datasets[datasetIndex].label;
            let filteredData;
            switch (datasetLabel) {
                case 'Orders Created':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.order_id !== 0
                    );
                    break;
                case 'Order Not Created':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.order_id === 0
                    );
                    break;
                case 'QC Approved':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.status_id === 48 && item.order_id !== 0
                    );
                    break;
                case 'In Process Cases':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.status_id !== 48 && item.order_id !== 0
                    );
                    break;
                default:
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel
                    );
            }
            setSelectedBarData(filteredData);
            setClickedDatasetLabel(datasetLabel);
            setCurrentPage(1);
            setShowBarTable(prev => {
                setShowTable(false);
                setShowTable1(false);
                const newValue = !prev;
                if (newValue) {
                    setTimeout(() => {
                        tableRef.current?.scrollIntoView({ behavior: 'smooth' });
                    }, 50);
                }
                return newValue;
            });
        }
    }, [barChartData, apiData]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom", labels: {
                    font: {
                        weight: 'bold'
                    }
                }, onHover: (event) => {
                    event.native.target.style.cursor = "pointer";
                }
            },
            title: { display: true }
        },
        scales: {
            x: {
                grid: { display: false }, title: {
                    display: true,
                    text: "Date",
                    font: {
                        size: 14,
                        weight: "bold"
                    }
                },
                ticks: {
                    font: {
                        weight: "bold"
                    }
                }
            },
            y: {
                beginAtZero: true, title: {
                    display: true,
                    text: "Conversion Count",
                    font: {
                        size: 14,
                        weight: "bold"
                    }
                },
                ticks: {
                    font: {
                        weight: "bold"
                    }
                }
            },
        },
        onHover: (event, chartElement) => {
            if (chartElement.length) {
                event.native.target.style.cursor = "pointer"; // Change to hand icon when hovering
            } else {
                event.native.target.style.cursor = "default"; // Reset cursor when not hovering
            }
        },
        onClick: (event, elements) => handleBarClick(elements)
    };

    return (
        <div style={{ width: "100%", padding: "40px" }}>
            <div style={{ fontSize: "19px", textAlign: "center", marginBottom: "40px", textDecoration: "underline" }}>
                <h5><b>{title}</b></h5>
            </div>

            {/* Bar Chart */}
            <div style={{ marginBottom: "50px", height: "400px", fontFamily: 'Lexend Deca' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h5 style={{
                        marginBottom: "10px", paddingLeft: '20px'
                    }}><b>ESales Conversion Till QC</b></h5>

                    <div style={{ marginBottom: '10px', fontSize: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                        <label style={{ display: 'block', fontWeight: 'bold', paddingRight: "5px" }}>Start Date:</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{
                                padding: '5px',
                                border: '1px solid #ccc',
                                borderRadius: '20px',
                                marginRight: '10px',
                                width: '150px',
                                height: '25px'
                            }}
                        />

                        <label style={{ display: 'block', fontWeight: 'bold', paddingRight: "5px", paddingLeft: "10px" }}>End Date:</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={{
                                padding: '5px',
                                border: '1px solid #ccc',
                                borderRadius: '20px',
                                marginRight: '10px',
                                width: '150px',
                                height: '25px'
                            }}
                        />

                        <button style={{
                            border: '1px solid black',
                            padding: '0px 10px',
                            paddingBottom: '20px',
                            borderRadius: '6px',
                            backgroundColor: '#f0f0f0',
                            cursor: 'pointer',
                            marginLeft: '5px',
                            height: '20px'
                        }} onClick={fetchData}>Submit</button>
                    </div>

                    {/* 
                        code for filter <select
                        style={{ borderRadius: '6px', border: '1px solid #ccc',fontSize:"14px" ,marginBottom: "10px"}}
                        onChange={(e) => {
                                const days = parseInt(e.target.value);
                                const filteredData = processData(apiData).filter(item => {
                                const itemDate = new Date(item.date);
                                const cutoffDate = new Date();
                                cutoffDate.setDate(cutoffDate.getDate() - days);
                                return itemDate >= cutoffDate;
                            });
                            setBarChartData(formatBarChartData(filteredData));
                            setLineChartData(formatBarChartData(filteredData));

                        }}
                        defaultValue="7">
                        <option value="7">Last 7 Days</option>
                        <option value="5">Last 5 Days</option>
                        <option value="3">Last 3 Days</option>
                    </select>
                    */
                    }
                </div>
                {barChartData ? <Bar data={barChartData} options={options} /> : <p>Loading chart...</p>}
            </div>
            <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}></div>

            {/* Line Chart */}
            <div style={{ marginBottom: "50px", height: "400px", marginTop: "40px" }}>
                <h5 style={{ marginBottom: "10px", paddingLeft: '20px' }}>
                    <b> Percentage Wise Conversion</b>
                </h5>
                {lineChartData ? <Line data={lineChartData} options={options} /> : <p>Loading chart...</p>}
            </div>
            <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}></div>

            {/*Status wise Chart calling*/}
            <div style={{ alignItems: 'center', marginTop: "40px" }}>
                <StatusWiseChart setShowBarTable={setShowBarTable} setShowTable={setShowTable} showTable={showTable}
                    setShowTable1={setShowTable1} showTable1={showTable1} redirectToHistory={redirectToHistory} />
            </div>

            {/* Daily chart calling */}
            <div style={{ alignItems: 'center', marginTop: "40px" }}>
                <DailyChart setShowBarTable={setShowBarTable} setShowTable={setShowTable} showTable={showTable}
                    setShowTable1={setShowTable1} showTable1={showTable1} redirectToHistory={redirectToHistory} />
            </div>

            {/* For data chart */}
            {showBarTable && (
                <div ref={tableRef} style={{
                    position: 'relative',
                    fontFamily: 'Lexend Deca'
                }}>
                    <h5>
                        <b>
                            {clickedDatasetLabel} : {selectedBarData.length}
                        </b>
                    </h5>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '0.8em',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        fontFamily: 'Lexend Deca'
                    }}>
                        <thead>
                            <tr style={{ backgroundColor: '#46A6EA' }}>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000', borderRadius: '8px 0 0 0' }}>Date</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>Insurer ID</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>Insurer Name</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>ESales ID</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000', borderRadius: '0 8px 0 0' }}>Request ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedBarData
                                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                                .map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: 'white', color: '#000', textAlign: 'center' }}>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 0 8px' }}>{item.Date}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.insurer_id}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.insurer_name}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}><a>{item.esale_id}</a></td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 0 8px' }}>
                                            {item.request_id ? (
                                                <span style={{ color: 'blue', cursor: 'pointer' }} onClick={(e) => redirectToHistory(e, item.request_id)}>
                                                    {item.request_id}</span>) : ("-")}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <div style={{
                        position: 'absolute',
                        right: '0',
                        padding: '5px 10px',
                        fontWeight: 'bold',
                        fontSize: '0.9em',
                        color: '#000',
                    }}>
                        Showing {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, selectedBarData.length)} of {selectedBarData.length}
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '10px 0',
                        gap: '10px'
                    }}>
                        <button
                            onClick={handleDownloadCSV}
                            style={{
                                padding: '0px 10px',
                                backgroundColor: '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                fontFamily: 'Lexend Deca',
                                borderRadius: '3px',
                                cursor: 'pointer'
                            }} >
                            Export ⬇
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            disabled={currentPage === 1}
                            style={{
                                padding: '0px 10px',
                                backgroundColor: currentPage === 1 ? '#ccc' : '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '3px',
                                fontFamily: 'Lexend Deca',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}   >
                            Previous
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => prev + 1)}
                            disabled={currentPage * itemsPerPage >= selectedBarData.length}
                            style={{
                                padding: '0px 25px',
                                backgroundColor: currentPage * itemsPerPage >= selectedBarData.length ? '#ccc' : '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '3px',
                                fontFamily: 'Lexend Deca',
                                cursor: currentPage * itemsPerPage >= selectedBarData.length ? 'not-allowed' : 'pointer'
                            }}  >
                            Next
                        </button>
                    </div>
                    <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}> </div>
                </div>
            )}
        </div>
    );
};
export default Chart;
